// project-imports
import { handleDevelopers } from './types/developers';
import { handleDevelopments } from './types/developments';
import { handleDevelopmentCompanies } from './types/development-companies';
import { handlePages } from './types/pages';
import { handleProperties } from './types/properties';
import { handleMetrics } from './types/metrics';
import { handleMetricsV2 } from './types/metrics-v2';
import { handleBucket } from './types/bucket';
import { handleFiles } from './types/files';
import { handleStripe } from './types/stripe';
import { handleOffers } from './types/offers';
import { handleSettings } from './types/settings';
import { handleCognito } from './types/cognito';
import { handleProducts } from './types/products';
import { handleLogError } from './types/log-error';
import { handleCustomers } from './types/customers';
import { handleNotes } from './types/notes';
import { handleDTCommercial } from './types/dt-commercial';
import { handleDiscoveryTrip } from './types/discovery-trip';
import { handleDTNotes } from './types/dt-notes';
import { handleDTDevelopments } from './types/dt-developments';
import { handleDTIncidents } from './types/dt-incidents';
import { handleDTEvents } from './types/dt-events';
import { handleCommercial } from './types/commercial';
import { handleContactForm } from './types/contact-form';
import { handleConnectRequest } from './types/connect-request';
import { handleAI } from './types/ai';
import { handleDCRequests } from './types/dc-requests';
import { handleDTRequests } from './types/dt-requests';
import { handleNotifications } from './types/notifications';
import { handleInternationalConfirmation } from './types/international-confirmations';
import { handleDevelopmentEvents } from './types/development-events';
import { handleMail } from './types/mail';
import { handleAgentVerification } from './types/agent-verification';
import { handleBilling } from './types/billing';
import { handleLanding } from './types/landing';
import { handleSharedApiV2 } from './types/shared-api-v2';

export interface APIAction {
  type: 'api';
  entity: string;
  method?: string;
  data?: any; // JSON or param, mainly for create or update
  subData?: any; // JSON or param, mainly for create or update (auxiliar params like fk don't retrieve directly from data)
  id?: any; // read or update
  url?: any;
}

// ==============================|| ACTION MANAGER - API ||============================== //

export async function handleAPIAction(action: APIAction) {
  return new Promise((resolve, reject) => {
    switch (action.entity) {
      case 'developers':
        resolve(handleDevelopers(action));
        break;
      case 'development-companies':
        resolve(handleDevelopmentCompanies(action));
        break;
      case 'developments':
        resolve(handleDevelopments(action));
        break;
      case 'pages':
        resolve(handlePages(action));
        break;
      case 'properties':
        resolve(handleProperties(action));
        break;
      case 'metrics':
        resolve(handleMetrics(action));
        break;
      case 'metrics-v2':
        resolve(handleMetricsV2(action));
        break;
      case 'bucket':
        resolve(handleBucket(action));
        break;
      case 'files':
        resolve(handleFiles(action));
        break;
      case 'stripe':
        resolve(handleStripe(action));
        break;
      case 'offers':
        resolve(handleOffers(action));
        break;
      case 'settings':
        resolve(handleSettings(action));
        break;
      case 'cognito':
        resolve(handleCognito(action));
        break;
      case 'products':
        resolve(handleProducts(action));
        break;
      case 'log-error':
        resolve(handleLogError(action));
        break;
      case 'customers':
        resolve(handleCustomers(action));
        break;
      case 'notes':
        resolve(handleNotes(action));
        break;
      case 'dt-commercial':
        resolve(handleDTCommercial(action));
        break;
      case 'discovery-trip':
        resolve(handleDiscoveryTrip(action));
        break;
      case 'dt-notes':
        resolve(handleDTNotes(action));
        break;
      case 'dt-developments':
        resolve(handleDTDevelopments(action));
        break;
      case 'dt-incidents':
        resolve(handleDTIncidents(action));
        break;
      case 'dt-events':
        resolve(handleDTEvents(action));
        break;
      case 'commercial':
        resolve(handleCommercial(action));
        break;
      case 'contact-form':
        resolve(handleContactForm(action));
        break;
      case 'connect-request':
        resolve(handleConnectRequest(action));
        break;
      case 'ai':
        resolve(handleAI(action));
        break;
      case 'dc-requests':
        resolve(handleDCRequests(action));
        break;
      case 'dt-requests':
        resolve(handleDTRequests(action));
        break;
      case 'notifications':
        resolve(handleNotifications(action));
        break;
      case 'international-confirmation':
        resolve(handleInternationalConfirmation(action));
        break;
      case 'development-events':
        resolve(handleDevelopmentEvents(action));
        break;
      case 'mail':
        resolve(handleMail(action));
        break;
      case 'agent-verification':
        resolve(handleAgentVerification(action));
        break;
      case 'billing':
        resolve(handleBilling(action));
        break;
      case 'landing':
        resolve(handleLanding(action));
        break;
      case 'shared-api-v2':
        resolve(handleSharedApiV2(action));
        break;
      default:
        console.info('[ApiManager > handleAPIAction] - Unknown method');
        break;
    }
  });
}
